
import React from 'react';
import PropTypes from 'prop-types';

/* istanbul ignore next */
const SearchCarrierConnect = (props) => {
    const { searchKeyword, handleSearchText, handleReset, handleSearchFilter, userDetails, lastSearchedKeyword, placeholderText } = props;

    const handleEnterClick = (e) => {
        if (e.key === "Enter") {
            handleSearchFilter(null, "search");
        }
    };

    // Role-based placeholder logic
    const getPlaceholderText = () => {
        if (userDetails?.Value?.isSuperAdmin) {
            return "Search by Carrier Connect Id, Tracking Number, Sub Tracking Number, Company Name, Seller Name, Seller Code, Notes, Billing Status or STE Code";
        } else {
            return "Search by tracking number and sub tracking number only";
        }
    };

    return (
        <div>
        {lastSearchedKeyword && (
                <div className="search-result-text mb-3" style={{ 
                    fontSize: '13px', 
                    color: '#007bff', 
                    fontWeight: '600',
                    backgroundColor: '#f8f9fa',
                    padding: '8px 12px',
                    borderRadius: '6px',
                    border: '1px solid #e3f2fd',
                    boxShadow: '0 1px 3px rgba(0,123,255,0.1)',
                    display: 'inline-flex',
                    alignItems: 'center',
                    marginBottom: '12px'
                }}>
                    <i className="fa fa-search" style={{ marginRight: '8px', color: '#007bff', fontSize: '12px' }}></i>
                    <span>Search results for : </span>
                    <span style={{ 
                        color: '#495057', 
                        fontWeight: '700',
                        backgroundColor: '#ffffff',
                        padding: '2px 6px',
                        borderRadius: '4px',
                        marginLeft: '4px',
                        border: '1px solid #dee2e6'
                    }}>
                        {lastSearchedKeyword}
                    </span>
                </div>
            )}
        <div className="filterContainer show searchBox mb-3">
            <div className="searchInputBox">
                <input
                    value={searchKeyword || ""}
                    type='text'
                    onChange={(e) => handleSearchText(e.target.value)}
                    className="form-control searchInput"
                    placeholder={placeholderText || getPlaceholderText()}
                    onBlur={(e) => handleSearchText(e.target.value.trim())}
                    onKeyDown={handleEnterClick}
                    autoFocus={true}
                />
            </div>
            <button
                // Enable reset when there is text in the search input OR when a previous search result exists
                disabled={!(searchKeyword || lastSearchedKeyword)}
                className="btn cus-primary-transparent-btn clrBtn"
                onClick={handleReset}
            >
                Reset
            </button>
            <button
                className="btn cus-seconday-bg-btn marginLeft5 searchBtn"
                onClick={() => handleSearchFilter(null, "search")}
            >
                <i className="fa fa-search" aria-hidden="true"></i> Search
            </button>
        </div>
        </div>
    );
}

SearchCarrierConnect.propTypes = {
    searchKeyword: PropTypes.string,
    handleSearchText: PropTypes.func.isRequired,
    handleReset: PropTypes.func.isRequired,
    handleSearchFilter: PropTypes.func.isRequired,
    userDetails: PropTypes.shape({
        Value: PropTypes.shape({
            isSuperAdmin: PropTypes.bool
        })
    }),
    lastSearchedKeyword: PropTypes.string,
    placeholderText: PropTypes.string
};

export default SearchCarrierConnect;
